import React from "react";
import "./IBStatus.css";

const IBStatus= () => {
  return (
    <div className="main-content">
      <div className="breadcrumb">
        Home / <span>View All</span>
      </div>
      <h2>IB Status List</h2>

      <div className="page-header">
        <div>
          <h2>View all IB status
          </h2>
          
        </div>
        <div className="header-buttons">
        
          <button className="btn blue">+ Create New</button>
        </div>
      </div>

      <div className="card">
        <div className="top-controls">
          
          <div className="search-box">
            Search: <input type="text" />
          </div>
        </div>

        <div className="buttons">
          <button>Copy</button>
          <button>CSV</button>
          <button>Excel</button>
          <button>PDF</button>
          <button>Print</button>
          <button className="dropdown">Column visibility ▾</button>
        </div>

        <table>
          <thead>
            <tr>
              <th>#</th>
              <th>Status Name</th>
              <th>Active/Inactive</th>
              <th>Actions</th>
              
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colSpan="11" className="empty">
                No data available in table
              </td>
            </tr>
          </tbody>
        </table>

        <div className="table-footer">
          <p>Showing 0 to 0 of 0 entries</p>
          <div>
            <button disabled>Previous</button>
            <button disabled>Next</button>
          </div>
        </div>
      </div>

      <footer>
        <p>
          Copyright © 2025 <span className="brand">Ample Markets</span>. All
          rights reserved. <span className="version">Version 2.0</span>
        </p>
      </footer>
    </div>
  );
};

export default IBStatus;
